const parseUserAgent = (ua = navigator.userAgent) => {
  let browser = 'Unknown browser'
  let os = 'Unknown OS'

  if (/Edg\/(\d+)/.test(ua)) browser = `Edge ${ua.match(/Edg\/(\d+)/)[1]}`
  else if (/Chrome\/(\d+)/.test(ua)) browser = `Chrome ${ua.match(/Chrome\/(\d+)/)[1]}`
  else if (/Firefox\/(\d+)/.test(ua)) browser = `Firefox ${ua.match(/Firefox\/(\d+)/)[1]}`
  else if (/Version\/(\d+)/.test(ua) && /Safari/.test(ua)) browser = `Safari ${ua.match(/Version\/(\d+)/)[1]}`

  if (/Windows NT 10/.test(ua)) os = 'Windows 10/11'
  else if (/Windows NT 6\.3/.test(ua)) os = 'Windows 8.1'
  else if (/Windows NT 6\.2/.test(ua)) os = 'Windows 8'
  else if (/Mac OS X ([\d_]+)/.test(ua)) os = `macOS ${ua.match(/Mac OS X ([\d_]+)/)[1].replace(/_/g, '.')}`
  else if (/Android (\d+)/.test(ua)) os = `Android ${ua.match(/Android (\d+)/)[1]}`
  else if (/iPhone OS/.test(ua)) os = 'iOS'
  else if (/Linux/.test(ua)) os = 'Linux'

  return `${browser} on ${os}`
}

export default parseUserAgent
